// User
import assessmentList from '../pages/assessment/assessmentList.vue';
import assessmentNew from '../pages/assessment/assessmentNew.vue';
import editAssessment from '../pages/assessment/editAssessment.vue';
import createAssessment from '../pages/assessment/createAssessment.vue';
import ageGroup from '../pages/assessment/ageGroup.vue';
import importAssessment from '../pages/assessment/importAssessment.vue';

const routes = [
  { // assessments/age-group
    path: 'assessments/age-group',
    name: 'age-group',
    component: ageGroup,
    meta:{
      name: 'Assessments Age Group',
      requireAuth: true
    },
    props: true
  },
  { // /assessments/import
    path: 'assessments/import',
    name: 'import-assessment',
    component: importAssessment,
    meta:{
      name: 'Import Assessments',
      requireAuth: true
    }
  },
  { // /assessments
    path: '/assessments',
    name: 'package-assessment-list',
    component: createAssessment,
    meta:{
      name: 'Assessments',
      requireAuth: true
    },
  },
  { // /package/:package_id/assessment/:trait_id
    path: 'package/:package_id/assessment/:trait_id',
    name: 'assessment-list',
    component: assessmentList,
    meta:{
      name: 'Assessment List',
      requireAuth: true
    },
    props: true
  },
  { // package/:package_id/assessment/:trait_id/new
    path: 'package/:package_id/assessment/:trait_id/new',
    name: 'new-assessment',
    component: assessmentNew,
    // component: createIntervention,
    meta:{
      name: 'Create Assessment',
      requireAuth: true
    },
    props: true
  },
  { // assessments/:id
    path: 'assessments/:id',
    name: 'edit-assessment',
    component: editAssessment,
    meta:{
      name: 'Edit Assessment',
      requireAuth: true
    },
    props: true
  },
]

export default routes